import React from 'react';

import { Button, Input, Checkbox, Tooltip } from '@salesforce/design-system-react';

const CustomPersona = (props) => {
  return (
    <React.Fragment>
      <div className="slds-grid slds-gutters">
        <div className="slds-col slds-size_1-of-4" />
        <div className="slds-col slds-size_2-of-4">
          <Input
            label="Name:"
            assistiveText={{ label: 'Name:' }}
            required
            onChange={(e) => props.updateName(e)}
            value={props.name}
            fieldLevelHelpTooltip={
              <Tooltip
                align="right"
                content="Get creative. Pick a first name AND last name."
                variant="learnMore"
              />
            }
          />
          <Input
            label="Role:"
            required
            onChange={(e) => props.updateRole(e)}
            value={props.role}
            fieldLevelHelpTooltip={
              <Tooltip
                align="right"
                content="E.g. small business customer"
                variant="learnMore"
              />
            }
            className="slds-p-vertical_medium"
          />
          <div className="slds-grid">
            <div className="slds-col slds-size_1-of-2">
              <Checkbox
                assistiveText={{
                  label: 'Hero',
                }}
                labels={{
                  label: <span className="slds-text-heading_small">Hero</span>,
                }}
                checked={props.hero}
                onChange={(e) => props.updateHero(e)}
                className="slds-p-bottom_medium"
              />
            </div>
            <div className="slds-col slds-size_1-of-2">
              <Button
                label={ props.editing ? "Update Persona" : "Create Persona" }
                onClick={props.onClick}
                variant="outline-brand"
              />
            </div>
          </div>
        </div>
        <div className="slds-col slds-size_1-of-4" />
      </div>      
    </React.Fragment>
  );
};

export default CustomPersona;
